import auth from "@/middleware/auth";
import { routes as minhasDividas } from "./minhasDividas/";
import { routes as cadastro } from "./cadastro/";
import { routes as comprovante } from "./comprovante/";
import { routes as meusAcordos } from "./meusAcordos/";
import { routes as negociarDivida } from "./negociarDivida/";
import { routes as meusBoletos } from "./meusBoletos/";
import { routes as negociar } from "./negociar/";
import { routes as vencimentoAVista } from "./vencimentoAVista/";
import { routes as vencimentoParcelas } from "./vencimentoParcelas/";
import { routes as acordoFechado } from "./acordoFechado/";
import { routes as resumoAcordoTribanco } from "./resumoAcordoTribanco/";
import { routes as resumoAcordoTricard } from "./resumoAcordoTricard/";
import { routes as acordoFechadoParcelas } from "./acordoFechadoParcelas/";
import { routes as propostasTribanco } from "./propostasTribanco/";
import { routes as propostas } from "./propostas/";
import { routes as concluir } from "./concluir/";


export default [
    {
        path: "/dashboard",
        component: () => import(/* webpackChunkName: "dashboard-layout" */ "@/modules/layout/DashboardLayout"),
        children: [
            {
                path: "/",
                name: "dashboard",
                meta: { middleware: [auth] },
                component: () => import(/* webpackChunkName: "dashboard" */ "./Dashboard")
            },
            ...minhasDividas,
            ...meusAcordos,
            ...cadastro,
            ...negociarDivida,
            ...meusBoletos,
            ...comprovante,
            ...negociar,
            ...vencimentoAVista,
            ...vencimentoParcelas,
            ...acordoFechado,
            ...acordoFechadoParcelas,
            ...resumoAcordoTribanco,
            ...resumoAcordoTricard,
            ...propostasTribanco,
            ...propostas,
            ...concluir,
        ]
    }
];